import { useObserver } from "mobx-react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";

export default function MediaPopup() {
  const { PopupStore } = useStores();

  const closeMediaPopup = () => {
    PopupStore.setMediaPopup(false);
    PopupStore.setMediaType(null);
    PopupStore.setMediaUrl(null);
  };

  return useObserver(() => {
    return (
      <>
        {PopupStore.mediaPopup && (
          <div
            onClick={closeMediaPopup}
            className="fixed w-screen h-screen z-40 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[50%] lg:w-[35%] w-[90%] min-h-[50%] h-fit m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <div className="flex flex-col gap-6 justify-between items-start p-6 h-full py-5 w-[100%]">
                <span className="text-primary rounded-full flex items-justify-between">
                  <AiOutlineCloseCircle
                    className="w-5 h-5 cursor-pointer absolute text-xl top-2 right-2"
                    onClick={closeMediaPopup}
                  />
                </span>

                <div className="w-full flex justify-center items-center">
                  {PopupStore.mediaType === "image" ? (
                    <img
                      src={PopupStore.mediaUrl}
                      alt="Media content"
                      className="max-w-full max-h-[50vh] object-contain"
                    />
                  ) : PopupStore.mediaType === "video" ? (
                    <video
                      src={PopupStore.mediaUrl}
                      controls
                      className="max-w-full max-h-[50vh]"
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  });
}
